import { cdnImage } from "../common/utils/image.util";

/**
 * Note: The quality and format to customize images are mutually exclusive.
 */
export type StoryblokImageFilter = {
    height?: number;
    width?: number;
};

// TODO remove this duplicate instance altogether
export function optimizeImageUrl(url: string, filter: StoryblokImageFilter) {
    return cdnImage(url, filter);
}
